'use client';

import { useApplyJob } from '@/modules/job/application';

import { useToast } from '@packages/web-design-systems';

export const useApplyJobHandler = () => {
	const applyJob = useApplyJob();
	const { showError, showSuccess } = useToast();

	const execute = async (jobId: string) => {
		const result = await applyJob.submit(jobId);

		if (result.isFailure) {
			showError({ title: 'Unable to apply job' });

			return;
		}

		showSuccess({ title: 'Job Application Success' });
	};

	return { execute, isSuccess: applyJob.isSuccess };
};
